import type { OrgDashboardApiOrg } from '#/modules/orgDashboard/api/types/OrgDashboardApiOrg';

export type OrgDashboardApiOrgWithListingPrices = OrgDashboardApiOrg & {
  prices: OrgDashboardApiOrg['prices'] & {
    listings: { JOB: number; INTERNSHIP: number };
    usListings: { JOB: number; INTERNSHIP: number };
  };
};

// Prices are null for org types that cannot post jobs/internships (groups).
export function orgHasListingPrices(
  org: OrgDashboardApiOrg,
): org is OrgDashboardApiOrgWithListingPrices {
  return (
    org.prices.listings.JOB !== null &&
    org.prices.listings.INTERNSHIP !== null &&
    org.prices.usListings.JOB !== null &&
    org.prices.usListings.INTERNSHIP !== null
  );
}
